import React, {PureComponent, Fragment} from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import Button from '../Button';
import Icon from '../Icon';
import Overlay from '../Overlay';
import VisibilityAnimation from '../VisibilityAnimation';
import Sidebar from '../Sidebar';

class Header extends PureComponent {
  static defaultProps = {
    showTitle: true
  };

  state = {
    menuOpen: false,
    optionsOpen: false
  };

  toggleOptions = () => {
    this.setState(prevState => ({
      optionsOpen: !prevState.optionsOpen
    }));
  }

  toggleMenu = () => {
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen
    }));
  }

  handleOverlayClick = () => {
    this.setState(prevState => ({
      [prevState.menuOpen ? 'menuOpen' : 'optionsOpen']: false
    }));
  }

  renderActions = isSmallScreen => {
    let {actions} = this.props;

    if (!actions) {
      return null;
    }

    if (!Array.isArray(actions)) {
      actions = [actions];
    }

    if (!isSmallScreen) {
      actions = [actions[0]];
    }

    return (
      <Actions>
        {actions.map((action, i) => {
          if (action && action.type === Button) {
            // Force specific styling on buttons in the header actions.
            action = React.cloneElement(action, {
              shadow: !isSmallScreen,
              primary: !isSmallScreen,
              secondary: isSmallScreen,
              block: isSmallScreen,
              large: false
            });
          }

          return <Action key={i}>{action}</Action>;
        })}
      </Actions>
    );
  }

  renderResponsive = isSmallScreen => {
    const {title, tabs, actions, activeLink, showTitle, labels, logoSrc} = this.props;
    const {optionsOpen, menuOpen} = this.state;

    return (
      <Fragment>
        <Container showTitle={showTitle}>
          <Title>
            <MenuButton onClick={this.toggleMenu}>
              <Icon name="menu" size="1.625em" />
            </MenuButton>
            {showTitle && <H1>{title}</H1>}
          </Title>
          {actions && (
            <ExpandOptionsButton onClick={this.toggleOptions}>
              <Icon name="more-vertical" size="1.625em" />
            </ExpandOptionsButton>
          )}
          {!isSmallScreen && this.renderActions(isSmallScreen)}
        </Container>
        {tabs ? <TabsContainer>{tabs}</TabsContainer> : (showTitle && <Divider />)}
        {isSmallScreen && (
          <Fragment>
            <Overlay visible={optionsOpen || menuOpen} onClick={this.handleOverlayClick} />
            <MobileSidebar show="slide-in-left" hide="slide-out-left" visible={menuOpen}>
              <Sidebar activeLink={activeLink} {...labels} logoSrc={logoSrc}/>
            </MobileSidebar>
            <MobileActions show="slide-in-up" hide="slide-out-down" visible={optionsOpen}>
              {this.renderActions(isSmallScreen)}
            </MobileActions>
          </Fragment>
        )}
      </Fragment>
    );
  }

  render() {
    return <MediaQuery maxWidth={800} children={this.renderResponsive} />;
  }
}

const Container = styled.div`
  display: flex;
  margin: ${props => props.showTitle ? `1.875rem` : `0`};

  @media (max-width: 800px) {
    margin: 1.25rem;
    margin-bottom: 0;
  }
`;

const Divider = styled.div`
  height: 0.0625rem;
  background: #E1E5EB;
  margin: 1.25rem;
  margin-top: 0;
  
  @media (min-width: 801px) {
    display: none;
  }
`;

const Title = styled.div`
  flex: 1;
  min-width: 0;
`;

const H1 = styled.h1`
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 800px) {
    padding: 1rem 0;
    font-size: 2.25rem;
  }
`;

const MobileSidebar = styled(VisibilityAnimation)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  background: none;
  overflow: auto;
  z-index: 30;
`;

const MobileActions = styled(VisibilityAnimation)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
`;

const Actions = styled.div`
  @media (min-width: 801px) {
    display: flex;
    align-items: center;
  }

  @media (max-width: 800px) {
    background: #FFF;
    padding: 1.25rem;
    border-radius: 0.625rem 0.625rem 0 0;
  }
`;

const Action = styled.div`
  margin-top: 1rem;

  :first-child {
    margin-top: 0;
  }
`;

const MenuButton = styled(props => <Button blank {...props} />)`
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  background: linear-gradient(30deg, #0049ee, #107aff);
  border-radius: 50%;

  @media (min-width: 801px) {
    display: none;
  }
`;

const ExpandOptionsButton = styled(props => <Button blank {...props} />)`
  color: #747474;
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: 801px) {
    display: none;
  }
`;

const TabsContainer = styled.div`
  margin-bottom: 1.875rem;
`;

export default Header;